import { Component, OnInit, ViewChild } from '@angular/core';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ActivatedRoute } from '@angular/router';
import { AutomatedSmartIrrigationSchedule, ManualSmartIrrigationSchedule, SmartIrrigationAlarm, SmartIrrigationControllerDashboard, SmartIrrigationDashboard, SmartIrrigationSchedule } from 'src/api/models';
import { SmartIrrigationService } from 'src/api/services';
import { ToastrService } from 'ngx-toastr';
import { AzureAuthService } from 'src/service/azure-auth.service';
@Component({
  selector: 'app-smart-irrigation-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class SmartIrrigationDashboardComponent implements OnInit {

  public viewMode: 'grid' | 'table' = 'grid';
  public model: SmartIrrigationDashboard;
  public controllers: SmartIrrigationControllerDashboard[];
  public alarms: SmartIrrigationAlarm[];

  public editController: SmartIrrigationControllerDashboard;

  constructor(private route: ActivatedRoute,
    public app: ApplicationConfigService,
    public auth: AzureAuthService,
    private irrigation: SmartIrrigationService,
    private toaster: ToastrService
  ) { }

  syncing: boolean = false;
  ngOnInit(): void {
    this.syncing = true;
    this.irrigation.SmartIrrigationGetDashboard(this.app.customerId).subscribe(model => {
      console.log('Irrigation Model',   model);
      this.model = model;
      this.controllers = Object.values(model.irrigationControllers);
      this.syncing = false;
    });
    this.irrigation.SmartIrrigationGetAlarms(this.app.customerId).subscribe(alarms => {
      console.log(alarms);
      this.alarms = alarms;
    });
  }
  
  masterEditSchedules: AutomatedSmartIrrigationSchedule[];
  manualEditSchedules: ManualSmartIrrigationSchedule[];
  startEditController(controller: SmartIrrigationControllerDashboard) {
    // show modal to edit the soil moisture threshold
    this.editController = controller;
    this.irrigation.SmartIrrigationGetAutomatedSchedules(this.app.customerId).subscribe(schedules => {
      console.log('schedules', schedules);
      this.masterEditSchedules = schedules.filter(s => s.controllerDeviceEui == controller.deviceEui);
    });
    this.irrigation.SmartIrrigationGetSchedules(this.app.customerId).subscribe(schedules => {
      console.log('manual schedules', schedules);
      this.manualEditSchedules = schedules.filter(s => s.controllerDeviceEui == controller.deviceEui);
      /*this.editSchedules = this.editSchedules.concat(this.manualEditSchedules.map(s => ({
          id: s.id,
          day: 'Manual',
          startHour: this.getHour(s.startTime),
          endHour: this.getHour(s.endTime)-1,
          cutoff: null
      }))); */
    });
  }

  selectedController: SmartIrrigationControllerDashboard;
  showStats(controller: SmartIrrigationControllerDashboard){
    this.selectedController = controller;
  }

  daysOfWeek: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  completeEditController(){
    //this.irrigation.SmartIrrigationUpdateAutomatedSchedule
    
  }

  getDayAsNumber(day: string):  0 | 1 | 2 | 3 | 4 | 5 | 6 {
    return this.daysOfWeek.indexOf(day) as 0 | 1 | 2 | 3 | 4 | 5 | 6;
  }

  onScheduleChange(schedule: any){
    console.log('schedule changed', schedule);  
    //for (let schedule of schedules) {
      console.log(schedule);
      // if schedule.id is null, create new schedule
      if (schedule.id != null) {
        const master = this.masterEditSchedules.find(s => s.id == schedule.id);
        this.irrigation.SmartIrrigationUpdateAutomatedSchedule({
          customerId: this.app.customerId,
          Id: schedule.id,
          ControllerDeviceEui: master.controllerDeviceEui,
          DayOfWeek: this.getDayAsNumber(schedule.day),
          StartTime: `${schedule.startHour.toString().padStart(2,'0')}:00`,
          EndTime: `${(schedule.endHour+1).toString().padStart(2,'0')}:00`,
          IrrigationCutoff: schedule.cutoff
        }).subscribe(r => {
          console.log('updated schedule', r);
          //schedule.id = r.id;
        });
      } else {
        this.irrigation.SmartIrrigationAddAutomatedSchedule({
          customerId: this.app.customerId,
          ControllerDeviceEui: this.editController.deviceEui,
          DayOfWeek: this.getDayAsNumber(schedule.day),
          StartTime: `${schedule.startHour.toString().padStart(2,'0')}:00`,
          EndTime: `${(schedule.endHour+1).toString().padStart(2,'0')}:00`,
          IrrigationCutoff: schedule.cutoff
        }).subscribe(r => {
          console.log('added schedule', r);
          schedule.id = r.id;
        });
      }
    //}
  }

  onScheduleAdd(schedule: any){
    console.log('schedule add', schedule);  
    //for (let schedule of schedules) {
      console.log(schedule);
      // if schedule.id is null, create new schedule
      if (schedule.id != null) {
        const master = this.masterEditSchedules.find(s => s.id == schedule.id);
        this.irrigation.SmartIrrigationUpdateAutomatedSchedule({
          customerId: this.app.customerId,
          Id: schedule.id,
          ControllerDeviceEui: master.controllerDeviceEui,
          DayOfWeek: this.getDayAsNumber(schedule.day),
          StartTime: `${schedule.startHour.toString().padStart(2,'0')}:00`,
          EndTime: `${(schedule.endHour+1).toString().padStart(2,'0')}:00`,
          IrrigationCutoff: schedule.cutoff
        }).subscribe(r => {
          console.log('updated schedule', r);
          this.toaster.success('Schedule updated');
          //schedule.id = r.id;
        }, error => {
          this.toaster.error('Error updating schedule');
        });
      } else {
        this.irrigation.SmartIrrigationAddAutomatedSchedule({
          customerId: this.app.customerId,
          ControllerDeviceEui: this.editController.deviceEui,
          DayOfWeek: this.getDayAsNumber(schedule.day),
          StartTime: `${schedule.startHour.toString().padStart(2,'0')}:00`,
          EndTime: `${(schedule.endHour+1).toString().padStart(2,'0')}:00`,
          IrrigationCutoff: schedule.cutoff
        }).subscribe(r => {
          console.log('added schedule', r);
          schedule.id = r.id;
          this.masterEditSchedules.push(r);
          this.toaster.success('Schedule added');
        }, error => {
          this.toaster.error('Error adding schedule');
        });
    }
  }

  minDisableUntil = new Date().toISOString().slice(0,16);
  maxDisableUntil = new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString().slice(0,16);
  toggleDisableFrom: string = '';
  toggleDisableUntil: string = '';
  isDisableUntilValid = false;

  validateDisableUntil() {
    /*this.isDisableUntilValid = !!this.toggleDisableUntil &&
      this.toggleDisableUntil >= this.minDisableUntil &&
      this.toggleDisableUntil <= this.maxDisableUntil;*/
      
      this.isDisableUntilValid = !!this.toggleDisableFrom && !!this.toggleDisableUntil &&
        this.toggleDisableFrom < this.toggleDisableUntil &&
        this.toggleDisableUntil >= this.minDisableUntil &&
        this.toggleDisableUntil <= this.maxDisableUntil;
  }

  toggleController: SmartIrrigationControllerDashboard;
  toggleControllerState(controller: SmartIrrigationControllerDashboard){
    /*this.irrigation.SmartIrrigationSetControllerState({
      customerId: this.app.customerId,  
      deviceEui: controller.deviceEui,
      allowIrrigation: !controller.currentState.value
    }).subscribe(r => {
      console.log('toggled controller', r);
      controller.currentState = r;
    });*/
    this.toggleController = controller;
  }

  completeToggleControllerState(){
    if (!this.isDisableUntilValid) {
      return;
    }
    this.irrigation.SmartIrrigationAddManualSchedule({
      customerId: this.app.customerId,  
      StartTime: this.toggleDisableFrom,
      EndTime: this.toggleDisableUntil,
      ControllerDeviceEui: this.toggleController.deviceEui,   
      timeZoneOffsetMinutes: new Date().getTimezoneOffset()
    }).subscribe(r => {
      //this.toaster
      console.log('added manual schedule', r);
      this.toggleController = null;
      this.toggleDisableUntil = '';
      this.isDisableUntilValid = false;
      this.toaster.success('Controller state toggled via manual schedule');
    }, error => {
      this.toaster.error('Error toggling controller state');
    });

  }

  onScheduleDelete(schedule: any){
    console.log('schedule delete', schedule);      
    // if schedule.id is null, create new schedule
    if (schedule.id != null) {
      const master = this.masterEditSchedules.find(s => s.id == schedule.id);
      this.irrigation.SmartIrrigationDeleteSchedule({
        customerId: this.app.customerId,
        scheduleId: schedule.id
      }).subscribe(r => {
        console.log('delete schedule', r);
        //schedule.id = r.id;
        this.toaster.success('Schedule deleted');
      }, error => {
        this.toaster.error('Error deleting schedule');
      });
    } 
  }

  deleteManualSchedule(schedule: ManualSmartIrrigationSchedule){
    this.irrigation.SmartIrrigationDeleteSchedule({
      customerId: this.app.customerId,
      scheduleId: schedule.id
    }).subscribe(r => {
      console.log('delete schedule', r);
      this.manualEditSchedules = this.manualEditSchedules.filter(s => s.id != schedule.id);
      this.toaster.success('Manual schedule deleted');
    }, error => {
      this.toaster.error('Error deleting manual schedule');
    });
  }
  
}